/**
 * Icon Mapping for Feature Flags
 * 
 * Maps feature keys to their corresponding Heroicons.
 * This allows dynamic route building from database feature flags
 * while keeping icon components in the frontend code.
 */

import {
  ChartPieIcon,
  QuestionMarkCircleIcon,
  Cog6ToothIcon,
  BoltIcon,
  ArchiveBoxIcon,
  DocumentChartBarIcon,
  WrenchScrewdriverIcon,
  PresentationChartLineIcon,
  CpuChipIcon,
  AdjustmentsHorizontalIcon,
  ShieldCheckIcon,
  EnvelopeIcon,
  LockClosedIcon,
  ChartBarIcon,
  BeakerIcon,
} from '@heroicons/react/24/outline';

/**
 * Map of feature keys to their icon components
 */
export const FEATURE_ICON_MAP: Record<string, React.ElementType> = {
  // Core features
  dashboard: ChartPieIcon,
  
  // Trading features
  live_trades: BoltIcon,
  closed_trades: ArchiveBoxIcon,
  
  // Analytics features
  strategy_details: DocumentChartBarIcon,
  portfolio_forecast: PresentationChartLineIcon,
  
  // Premium features
  portfolio_optimization: AdjustmentsHorizontalIcon,
  portfolio_command_center: CpuChipIcon,
  
  // Management features
  bot_maintenance: WrenchScrewdriverIcon,
  
  // Account features
  account_settings: Cog6ToothIcon,
  email_preferences: EnvelopeIcon,
  privacy_settings: LockClosedIcon,
  
  // Support features
  help_faq: QuestionMarkCircleIcon,
  
  // Admin features
  admin_panel: ShieldCheckIcon,
  real_time_diagnostic: ChartBarIcon,
  lifecycle_testing: BeakerIcon,
};

/**
 * Get icon component for a feature key
 * Returns QuestionMarkCircleIcon as fallback if feature key not found
 */
export const getIconForFeature = (featureKey: string): React.ElementType => {
  return FEATURE_ICON_MAP[featureKey] || QuestionMarkCircleIcon;
};
